"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1365],{

/***/ 71365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ colored_timer_vertical_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js + 5 modules
var vertical_timer_tabs = __webpack_require__(34864);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/default-props.js
var default_props = __webpack_require__(83246);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var getAsset = function(videoName) {
    return {
        video: {
            loop: false,
            src: {
                formats: [
                    "/static/video/capabilites_videos/".concat(videoName, ".mp4")
                ]
            }
        }
    };
};
/* harmony default export */ var colored_timer_vertical_tabs_default_props = (_object_spread_props(_object_spread({}, default_props/* default */.Z), {
    tabs: [
        {
            title: "1. Collaborate",
            content: {
                topic: {},
                title: "Accurately estimate costs and increase profitability",
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            timer: 1000 * 10,
            asset: getAsset("flexibility")
        },
        {
            title: "2. Connect",
            content: {
                topic: {},
                title: "Accurately estimate costs and increase profitability",
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            timer: 1000 * 10,
            asset: getAsset("insight")
        },
        {
            title: "3. Execute",
            content: {
                topic: {},
                title: "Accurately estimate costs and increase profitability",
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            timer: 1000 * 10,
            asset: getAsset("data-viz")
        }
    ],
    backgroundColor: "transparent",
    progressbarColor: "dodger-blue",
    showArrow: true,
    assetPosition: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
    showButton: false,
    buttonConfig: {},
    alwaysShowProgressbar: true,
    title: {
        fontColor: "silver",
        selectedFontColor: "dodger-blue",
        fontSize: "40px",
        selectedFontSize: "40px",
        fontWeight: "bold"
    }
}));

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/colored-timer-vertical-tabs-component.scss.js

var StyledColoredTimerVerticalTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ecn9yvg0"
})();

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/colored-timer-vertical-tabs-component.js
function colored_timer_vertical_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function colored_timer_vertical_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            colored_timer_vertical_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function colored_timer_vertical_tabs_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function colored_timer_vertical_tabs_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        colored_timer_vertical_tabs_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var ColoredTimerVerticalTabsComponent = function(props) {
    var contentRenderer = function(contentObject) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, colored_timer_vertical_tabs_component_object_spread_props(colored_timer_vertical_tabs_component_object_spread({}, contentObject), {
            titleSize: sizes.XS
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledColoredTimerVerticalTabsComponent, {
        className: "colored-timer-vertical-tabs-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_timer_tabs/* default */.Z, colored_timer_vertical_tabs_component_object_spread_props(colored_timer_vertical_tabs_component_object_spread({}, props), {
            tabContentRenderer: contentRenderer
        }))
    });
};
ColoredTimerVerticalTabsComponent.defaultProps = colored_timer_vertical_tabs_default_props;
/* harmony default export */ var colored_timer_vertical_tabs_component = (ColoredTimerVerticalTabsComponent);


/***/ })

}]);